import React from 'react';

interface LoadingProps {
    show: boolean;
    greyOut?: boolean;
    fullPage?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ show, greyOut, fullPage }) => {
    const showGreyOut = greyOut && show ? ' loader--grey-out' : '';
    const showFullPage = fullPage && show ? ' loader--full-page' : '';
    const showLoader = show ? ' loader__spinner--show' : '';
    return (
        <div className={`loader${showGreyOut}${showFullPage}`}>
            <img className={`loader__spinner${showLoader}`} />
        </div>
    );
};

export default React.memo(Loading);
